module.exports = __webpack_public_path__ + "static/media/linkedin.4bb5bd34.png";